const PENDING_SIGNUP_KEY = 'jashsoft_pending_signup';

export function savePendingSignup(signup) {
  sessionStorage.setItem(PENDING_SIGNUP_KEY, JSON.stringify(signup));
}

export function getPendingSignup() {
  const raw = sessionStorage.getItem(PENDING_SIGNUP_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

export function clearPendingSignup() {
  sessionStorage.removeItem(PENDING_SIGNUP_KEY);
}
